module.exports = __webpack_public_path__ + "static/media/video-advmindfulness-autopilot-en.8b439594.vtt";